module.exports = __webpack_public_path__ + "img/chord_1.d0867150.jpg";